export enum MapTechnology {
    FIBER = "fiber",
    COAX = "coax",
    MBB = "mbb",
}

export interface MapRegion {
    class: string
    display_name: string
    technology: MapTechnology
}

export type CoverMapRegionMap = { [key: string]: MapRegion }

export const BigCoverMapRegions: CoverMapRegionMap = {
    FIBER: {
        class: "fiber",
        display_name: "Fiber",
        technology: MapTechnology.FIBER
    },
    COAX: {
        class: "coax",
        display_name: "Kabel-tv-stik",
        technology: MapTechnology.COAX
    },
    MBB: {
        class: "mbb",
        display_name: "5G-Internet",
        technology: MapTechnology.MBB
    }
}

export const ALL_FIBER: MapRegion = {
    class: "fiber",
    display_name: "ALLE",
    technology: MapTechnology.FIBER
}

export const FiberCoverMapRegions: CoverMapRegionMap = {
    FIBER_TM: {
        class: "fiber-tm",
        display_name: "Thy-Mors Energi",
        technology: MapTechnology.FIBER
    },
    FIBER_TDC: {
        class: "fiber-tdc",
        display_name: "TDC NET",
        technology: MapTechnology.FIBER
    },
    FIBER_SEF: {
        class: "fiber-sef",
        display_name: "SEF",
        technology: MapTechnology.FIBER
    },
    FIBER_RAH: {
        class: "fiber-rah",
        display_name: "RAH",
        technology: MapTechnology.FIBER
    },
    FIBER_N: {
        class: "fiber-n",
        display_name: "Norlys",
        technology: MapTechnology.FIBER
    },
    FIBER_NE: {
        class: "fiber-ne",
        display_name: "Nord Energi",
        technology: MapTechnology.FIBER
    },
    FIBER_GC: {
        class: "fiber-gc",
        display_name: "GlobalConnect",
        technology: MapTechnology.FIBER
    },
    FIBER_F: {
        class: "fiber-f",
        display_name: "Fibia",
        technology: MapTechnology.FIBER
    },
    FIBER_E: {
        class: "fiber-e",
        display_name: "Ewii",
        technology: MapTechnology.FIBER
    },
    FIBER_EF: {
        class: "fiber-ef",
        display_name: "Energi Fyn",
        technology: MapTechnology.FIBER
    },
}

export function isSameRegion(a: MapRegion, b: MapRegion) {
    return a.class === b.class
}
